var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequirementsSelection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15.209,
    viewBox: "0 0 16 15.209",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5962",
    "data-name": "Group 5962",
    transform: "translate(-13521.467 -21599)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5961",
    "data-name": "Group 5961",
    transform: "translate(13521.467 21599)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-requirement-3194836",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5929",
    "data-name": "Path 5929",
    d: "M181.185,117.964a.582.582,0,0,0,.439.175.692.692,0,0,0,.439-.175l1.842-1.842a.608.608,0,1,0-.86-.86l-1.4,1.4-.561-.561a.608.608,0,1,0-.86.86Z",
    transform: "translate(-177.186 -112.469)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5930",
    "data-name": "Path 5930",
    d: "M346.132,145.144h4.263a.614.614,0,1,0,0-1.228h-4.263a.614.614,0,1,0,0,1.228Z",
    transform: "translate(-337.813 -140.425)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5931",
    "data-name": "Path 5931",
    d: "M181.185,233.884a.636.636,0,0,0,.877,0l1.842-1.842a.608.608,0,0,0-.86-.86l-1.4,1.4-.561-.561a.608.608,0,0,0-.86.86Z",
    transform: "translate(-177.186 -224.937)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5932",
    "data-name": "Path 5932",
    d: "M346.132,261.624h4.263a.614.614,0,1,0,0-1.228h-4.263a.622.622,0,0,0-.614.614A.634.634,0,0,0,346.132,261.624Z",
    transform: "translate(-337.813 -253.414)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5933",
    "data-name": "Path 5933",
    d: "M180.644,350.364a.582.582,0,0,0,.439.175.692.692,0,0,0,.439-.175l1.824-1.842a.608.608,0,1,0-.86-.86l-1.4,1.4-.561-.561a.608.608,0,1,0-.86.86Z",
    transform: "translate(-176.644 -337.949)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5934",
    "data-name": "Path 5934",
    d: "M346.132,377.544h4.263a.614.614,0,1,0,0-1.228h-4.263a.614.614,0,1,0,0,1.228Z",
    transform: "translate(-337.813 -365.86)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5935",
    "data-name": "Path 5935",
    d: "M99.409,27.441H84.588a.6.6,0,0,0-.59.59V42.06a.6.6,0,0,0,.59.59H99.409a.6.6,0,0,0,.59-.59V28.031a.586.586,0,0,0-.59-.589ZM98.819,41.47H85.177V28.6H98.819Z",
    transform: "translate(-83.998 -27.441)",
    fill: "#333"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequirementsSelection);
export default __webpack_public_path__ + "static/media/requirementsSelection.b974f923e6b861cabe85c788584bd6dc.svg";
export { ForwardRef as ReactComponent };